// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".boxFiltroTipoVerba{\n    flex-wrap: wrap!important;\n}\n\n.detalheSaibRadio{\n    padding: 10px 5px!important;\n}\n\n.titleFiltroTipoVerba{\n    font-weight: 700;\n    font-size: 1rem;\n}", ""]);
// Exports
module.exports = exports;
